import {Location} from '@angular/common';
import {Component, Injector} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../core/auth/auth.service';
import {RouteComponentBase} from '../core/route-component-base';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@drl/env/environment';
import {UserSessionStoreService as StoreService} from '@drl/core/store/user-session-store.service';
import {GetIpsAssetsCommand} from '@drl/core/store/commands';
import {ApiService} from '@drl/core/api/api.service';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {AuthTokenSkipHeader} from '@drl/core/interceptors/auth.interceptor';
import {TenantConfig} from '@drl/core/store/models';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {ConfigurationsFacadeService} from '@drl/shared/facades';
import {NbDialogService} from '@nebular/theme';
import {ActiveSessionDialogComponent} from '@drl/shared/components/active-session-dialog/active-session-dialog.component';

@Component({
  selector: 'ips-login',
  templateUrl: './login.component.html',
  styleUrls: [],
})
export class LoginComponent extends RouteComponentBase {
  logo = `/assets/logo.svg`;

  brnad = environment.brand;
  private readonly authHeaders = new HttpHeaders().set(AuthTokenSkipHeader, '');
  private dialogService: NbDialogService;
  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly location: Location,
    private readonly authService: AuthService,
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
    protected readonly translateSvc: IpsTranslateService,
    private readonly configurationFacade: ConfigurationsFacadeService,
    private readonly store: StoreService,
    private injector: Injector, // private readonly dialogService: NbDialogService
  ) {
    super(route, location);
    // this.getAssets();
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;

  protected router: Router;
  loading = false;
  user = {
    username: '',
    password: '',
    tenantName: '',
  };
  submitted: boolean;
  rememberMe: boolean;
  tenantsList = [];

  // getAssets(){
  //   const isWhiteLabelled = this.store.getIsWhiteLabelled();
  //   const command: GetIpsAssetsCommand<TenantConfig> = new GetIpsAssetsCommand(
  //     this.apiService,
  //     this.anyAdapter);

  //   command.parameters = {
  //     headers: this.authHeaders,
  //     query: new HttpParams().set('tenantId', ''+this.store.getTenantId()),
  //   };
  //   if(isWhiteLabelled && this.store.getTenantId())
  //   {
  //     command.execute().subscribe((assets:TenantConfig) => {
  //         this.logo = assets.configValue.logo ? assets.configValue.logo  :  '/assets/logo-alivius.png'
  //     })
  //   }
  //   else{
  //     this.logo = '/assets/logo-alivius.png'
  //   }
  // }
  ngOnInit() {
    // const isWhiteLabelled = this.store.getWhiteLabelled();
    // if(isWhiteLabelled && this.store.getTenantLogo()){
    //   this.logo = this.store.getTenantLogo();
    // }
    // else{
    //   this.logo = `/assets/logo.svg`;
    // }
  }

  // login(form: NgForm): void {
  //   if (form.invalid) {
  //     return;
  //   }
  //   this.loading = true;
  //   this._subscriptions.push(
  //     this.authService.login(this.user.username, this.user.password, this.store.getTenantName()).subscribe(
  //       response => {
  //         if (response.body) {
  //           this.authService.authorize(response.body);
  //         }
  //       },
  //       err => {
  //         this.loading = false;
  //         if(this.store.getActiveSessionModal()){
  //           if (!this.dialogService) {
  //             this.dialogService = this.injector.get(NbDialogService);
  //           }
  //           this.dialogService.open(ActiveSessionDialogComponent, {
  //             context: {
  //               username: this.user.username,
  //               password: this.user.password,
  //               tenantName: this.store.getTenantName(),
  //             },
  //             closeOnBackdropClick: false,
  //           }).onClose.subscribe(res => {

  //             this.store.setActiveSessionModal(false);
  //           });
  //         }
  //       },
  //     ),
  //   );
  // }

  login(form: NgForm): void {
    if (form.invalid) {
      return;
    }
    this.loading = true;
    this._subscriptions.push(
      this.authService
        .login(
          this.user.username,
          this.user.password,
          this.store.getTenantName(),
        )
        .subscribe(
          response => {
            this.loading = false;
            this.authService.otpPageRedirect();
          },
          err => {
            this.loading = false;
            if (this.store.getActiveSessionModal()) {
              if (!this.dialogService) {
                this.dialogService = this.injector.get(NbDialogService);
              }
              this.dialogService
                .open(ActiveSessionDialogComponent, {
                  context: {
                    username: this.user.username,
                    password: this.user.password,
                    tenantName: this.store.getTenantName(),
                  },
                  closeOnBackdropClick: false,
                })
                .onClose.subscribe(res => {
                  this.store.setActiveSessionModal(false);
                });
            }
          },
        ),
    );
  }
}
